import clsx from "clsx";
import styles from "./index.module.css";

const RaumaSymbol = ({ animated }: { animated: boolean }) => {
  //TODO implement animation
  return (
    <svg
      className={clsx(styles.raumaSymbol, styles.filled)}
      viewBox="0 0 48 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2_9)">
        <path
          d="M23.9728 25.7587V21.5815C23.9728 21.2621 24.2322 21.0028 24.5516 21.0028H47.999V20.9332V0H0V45.2083H5.95626V29.6583C5.95626 29.3389 6.2156 29.0796 6.53501 29.0796H41.4631C41.7825 29.0796 42.0418 29.3389 42.0418 29.6583V45.2083H47.999V26.3384H24.5516C24.2322 26.3384 23.9728 26.079 23.9728 25.7596V25.7587ZM42.0437 3.31994V17.6819C42.0437 18.0013 41.7844 18.2607 41.465 18.2607H6.53596C6.21655 18.2607 5.95721 18.0013 5.95721 17.6819V3.31994C5.95721 3.00054 6.21655 2.7412 6.53596 2.7412H41.465C41.7844 2.7412 42.0437 3.00054 42.0437 3.31994Z"
          fill="#21200A"
        />
      </g>
      <defs>
        <clipPath id="clip0_2_9">
          <rect width="48" height="45.2083" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RaumaSymbol;
